import { SvgProps } from './types'

export const OpenBoxIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="40"
      height="32"
      viewBox="0 0 40 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <g clipPath="url(#clip0_3733_1453)">
        <path
          d="M19.2323 0.521484L4.35571 6.5482L20.0157 13.8414L35.2644 6.5482L19.2323 0.521484Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.36355 15.7746L4.35571 24.103L20.0157 31.4824V14.1865"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.0156 31.4825L35.656 24.1461V14.8179"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.3557 6.56006L0.520996 13.4965L15.9068 21.3112L19.8081 13.9827"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.2643 6.54834L39.479 12.3868L24.0265 21.1897L20.2114 13.8572"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
